"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OAuthType = void 0;
var OAuthType;
(function (OAuthType) {
    OAuthType[OAuthType["registration"] = 0] = "registration";
    OAuthType[OAuthType["login"] = 1] = "login";
})(OAuthType || (exports.OAuthType = OAuthType = {}));
